const LoadMore = (() => {
  const getNextPage = async (nextUrl) => {
    try {
      const pageResponse = await fetch(nextUrl);

      return await pageResponse.text();
    } catch (error) {
      throw new Error(error);
    }
  };

  const openTab = (event) => {
    const tab = event.target.getAttribute('data-active-tab');

    document.getElementById(`${tab}`).scrollIntoView({ behavior: 'smooth' });
    document.querySelector(`#${tab} .search-results__tab-title`).click();
  };

  const loadMoreProducts = async () => {
    let productList;
    let productsContainer;
    const loadingOverlay = document.querySelector('.load-more .loading-overlay__spinner');
    const blogArticles = document?.querySelector('.featured-embla__container-grid-section');

    productsContainer = document?.querySelector('.product-list-wrapper .featured-embla__container-grid-section');

    if (document?.querySelector('.load-more__html-section')) {
      productsContainer = document.querySelector('.load-more__html-section');
    }

    if (blogArticles?.classList.contains('blogs-articles__list')) {
      productsContainer = document.querySelector('.blogs-articles__list.featured-embla__container-grid-section');
    }

    const loadMoreButtonWrapper = document.getElementById('load-more__btn');
    const { nextUrl } = loadMoreButtonWrapper.dataset;

    loadMoreButtonWrapper.classList.add('hidden');
    loadingOverlay.classList.remove('hidden');

    const nextPage = await getNextPage(nextUrl);
    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

    if (nextPageDoc.querySelector('.featured-product-listing')) {
      productList = nextPageDoc.querySelectorAll('.featured-embla__slide');
    } else if (nextPageDoc.querySelector('.product-search-wrapper .featured-embla__container-grid-section')) {
      productList = nextPageDoc.querySelectorAll('.featured-embla__container-grid-section .featured-embla__slide');
    } else if (nextPageDoc.querySelector('.featured-embla__container-grid-section')) {
      productList = nextPageDoc.querySelectorAll('.featured-embla__container-grid-section .blogs-article.featured-embla__section');
    } else if (nextPageDoc.querySelector('.load-more__html-section')) {
      productList = nextPageDoc.querySelectorAll('.featured-embla__section');
    } else {
      productList = nextPageDoc.querySelectorAll('.featured-embla__slide');
    }

    const loadMoreButton = nextPageDoc.getElementById('load-more__btn');

    productList.forEach((product) => {
      productsContainer.appendChild(product);
    });
    productList[0]?.querySelector("a").focus();

    if (loadMoreButton) {
      loadMoreButtonWrapper.parentNode.replaceChild(loadMoreButton, loadMoreButtonWrapper);
      // eslint-disable-next-line no-use-before-define
      initialize();
    } else {
      loadMoreButtonWrapper.style.display = 'none';
    }

    loadingOverlay.classList.add('hidden');
  };

  const initialize = () => {
    document.querySelector('#load-more__btn')?.addEventListener('click', loadMoreProducts);

    const redirectButtons = document.querySelectorAll('.goto__button');

    if (redirectButtons.length > 0) {
      redirectButtons.forEach((redirectButton) => {
        redirectButton.addEventListener('click', openTab);
      });
    }
  };

  return {
    initialize,
    loadMoreProducts,
  };
})();

LoadMore.initialize();
